
import { Component, OnInit, ViewChild } from '@angular/core';
import { Platform, ModalController, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService, MessageclientService, NativeService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from 'src/model/common';
declare var app;
@Component({
  selector: 'app-transfer-gifts-detail',
  templateUrl: './transfer-gifts-detail.component.html',
  styleUrls: ['./transfer-gifts-detail.component.scss']
})
export class TransferGiftsDetailComponent extends GridBaseCase {
  tabsIndex: any = 0;
  remarkvalue: any; //信息反馈字段
  outOrInType: string;//调出或者调入类型type
  outOrInName: string;
  pageName: string = null;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  addobject: any = {};//多选
  dataArrayList: Array<any> = [];//数据列表

  giftsCategoryID: any; // 产品分类的id
  arrayDatalist: Array<any> = [];
  _tempArray: Array<any> = [];
  imgUrlArr: Array<any> = [];

  arrayData: Array<any> = [];
  pageNameone: number = 0; // 产品所属于产品
  ID: string = "";
  current_obj: any = {};//当前对象

  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private route: ActivatedRoute,
    private msg: MessageclientService,
    private com: CommonService,
    private native: NativeService,
    public baseService: BaseCase,
    public base: BaseModal,
    public modal: ModalController,
  ) {
    super();
    this.baseService.arrayData = [];

    const ImgPreview = this.route.snapshot.queryParamMap.get("JsonData");

    this.current_obj = JSON.parse(ImgPreview);
    if (this.current_obj && this.current_obj.ID) {
      this.ID = this.current_obj.ID || "";
      // this.ID="818B98E2-A28D-4776-963A-DC24AC55F9DC";
    }
    if(this.current_obj.CargoDateTime){
      this.current_obj.CargoDateTime=this.current_obj.CargoDateTime.replace(/-/,"/");
    }
    if (this.current_obj) {
      if (this.current_obj["tabsTypeName"] == "in") {
        //
        this.outOrInName = "入";
        this.baseService.FixedSubmitBtn.text = "确认调入";
      } else {
        this.outOrInName = "出";
        this.baseService.FixedSubmitBtn.text = "确认调出";
      }
    }
    // this.getProductList();
    this.baseService.FixedSubmitBtn.configName = "TransferGiftsDetail";
    this.baseService.FixedSubmitBtn.isShow = true;
    this.baseService.FixedSubmitBtn.type = 14;
    this.LoadData(1);
  }

  ngOnInit() {
  }
  // tab切换
  ipcConten(item, num) {
    const that = this;
    that.tabsIndex = num;
    that.arrayDatalist = item["DetailList"] || [];

  }
  LoadData(pageNameone) {
    let that = this;
    that.pageNameone = pageNameone;
    
    let _dy: any = { "ID": that.ID };
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const pageid = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.ConfigName = "TBGiftsCargoPlanInfoSRL";
    body.OpType = "query";
    body.ConfigType = "view";
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    body.Client.Name = "product";
    body.RequestBody = JSON.stringify(_dy);
    that.http.post(app.DEFAULTURL, body).then(data => {
      that.arrayDatalist= [];
        that.apiObj['status'] = false;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      if (data.ResponseMessage.Success) {
        that.loading=true;
        if (data.Status && data.Status["infolist"]) {
          that.arrayData = data.Status["infolist"] || [];
          if( data.Status["infolist"].length>0){
            that.arrayDatalist = data.Status["infolist"][0]["DetailList"] || [];
            that.arrayDatalist.forEach(item=>{
              if (this.current_obj["tabsTypeName"] == "in") {
                item.kucun=item.a_InStock;
              }else{
                item.kucun=item.a_OutStock;
              }
            })
            that.arrayData.forEach(items=>{
              items.DetailList.forEach(item=>{
                if (this.current_obj["tabsTypeName"] == "in") {
                  item.kucun=item.a_InStock;
                }else{
                  item.kucun=item.a_OutStock;
                }
              })
            })
            
          }
        }
      }else{
        that.apiObj['status'] = false;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }
    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }

  //提交按钮
  EventSubmitClick() {
    const that = this;
    //  State  0：确认调出 1：确认调入
    that.msg.Confirm("确认提交吗？", "取消", "确定", "", false).then(res => {
      if(res){
        that.msg.Loading("请求中，请稍后...").then(load=>{
          let _dy: any = { "FK_TBGiftsCargoPlan_ID": that.ID };
          _dy["State"] = this.current_obj["tabsTypeName"] == "in" ? 1 : 0;
          const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
          const pageid = that.activaRouter.snapshot.paramMap.get('id');
          let body = new WebParameterContext();
          body.ConfigName = "GiftsConfirmInOrOut";
          body.OpType = "edite";
          body.ConfigType = "form";
          body.PageNumber = 1;
          body.Client.PageName = PageName;
          body.Client.ApiType = "Element";
          body.Client.ClientType = 2;
          body.Client.Name = "product";
          body.RequestBody = JSON.stringify(_dy);
          that.http.post(app.DEFAULTURL, body).then(data => {
            load.dismiss();
            if (data.ResponseMessage.Success) {
              that.msg.Alert("操作成功！").then(res=>{
                if(res){
                  that.com.goBack();
                }
             });
             
            } else {
              that.msg.Alert(data.ResponseMessage.ErrorMessage);
            }
          }).catch(error => {
            load.dismiss();
            that.apiObj['status'] = false;
            that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
            that.loading = true;
            console.log(error);
          });
          load.present();
        });
      }
      
    });
    
  }
}
